<template>
  <div
    id="experience"
    class="experiences obs-el"
    data-attr="experience"
  >
    <h2 class="title wrap">{{ t('popularExcursions', { place: inObjPhrase }) }}</h2>
    <div
      v-if="initialLoading"
      class="exp-snippet-list"
    >
      <slot />
    </div>
    <div
      v-else
      v-view-section-tracker="getSectionViewParams()"
      class="exp-snippet-list"
    >
      <slot />
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { useI18n } from '@experience/i18n';
  import { storeToRefs } from 'pinia';
  import { computed, ref, watch } from 'vue';

  import { ru } from '@/pages/regionArticles/features/experiencesList/i18n/ru';
  import { useExperienceEntity } from '@/entities/experience';

  interface Props {
    /**
     * Текст "в <Город>".
     */
    inObjPhrase: string;

    /**
     * Идентификатор города.
     */
    subjectGeoId: number;

    /**
     * Название города.
     */
    subjectGeoName: string;

    /**
     * Флаг загрузки сторонних данных.
     *
     * Данный флаг нужен для того, чтобы не отсылать события аналитики до того
     * как загрузятся все данные, отправляемые в событиях.
     */
    generalPageDataLoading: boolean;
  }

  const props = defineProps<Props>();

  const { t } = useI18n({ inheritLocale: true, messages: { ru } });

  const experienceEntity = useExperienceEntity();
  const { loading: experienceLoading } = storeToRefs(experienceEntity);
  const initialLoading = ref(true);
  const loading = computed(() => experienceLoading.value || props.generalPageDataLoading);

  const getSectionViewParams = () => ({
    subject_geo_id: props.subjectGeoId,
    subject_geo_name: props.subjectGeoName,
    subject_geo_type: 'city',
    section_type: 'experience',
  });

  watch(
    () => loading.value,
    () => {
      if (!loading.value) {
        initialLoading.value = false;
      }
    },
  );
</script>

<style lang="scss" scoped>
  .experience {
    margin-bottom: 80px;

    @include tablet {
      margin-bottom: 60px;
    }
  }

  .exp-snippet-list {
    margin: 30px 0 0;
  }

  .title {
    font-weight: 800;
    font-size: 32px;
    line-height: 40px;

    @include tablet {
      font-size: 24px;
      line-height: 32px;
    }
  }
</style>
